import { Controller } from '@hotwired/stimulus'

// Opens/closes a modal dialog.
// Usage:
//   <div data-controller="modal">
//     <button data-action="modal#open">Open</button>
//     <div data-modal-target="dialog" class="hidden ...">
//       <button data-action="modal#close">Cancel</button>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ['dialog']

  connect() {
    if (this.dialogTarget.classList.contains('hidden')) {
      document.body.classList.remove('overflow-hidden')
    } else {
      document.body.classList.add('overflow-hidden')
    }
  }

  open() {
    this.dialogTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.dialogTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  // Close when clicking the backdrop (the outer overlay element)
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  // Close on Escape key
  closeOnEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
